import { baseApiClient as api } from "../baseService";

export const addTagTypes = ["templates"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      templateList: build.query<TemplateListApiResponse, TemplateListApiArg>({
        query: (queryArg) => ({
          url: `/api/templates/`,
          params: {
            category: queryArg.category,
            firm_id: queryArg.firmId,
            is_default: queryArg.isDefault,
            limit: queryArg.limit,
            offset: queryArg.offset,
            ordering: queryArg.ordering,
            scope: queryArg.scope,
            search: queryArg.search,
            status: queryArg.status,
            template_format: queryArg.templateFormat,
          },
        }),
        providesTags: ["templates"],
      }),
      templateCreate: build.mutation<
        TemplateCreateApiResponse,
        TemplateCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/`,
          method: "POST",
          body: queryArg.createTemplate,
        }),
        invalidatesTags: ["templates"],
      }),
      templateRetrieve: build.query<
        TemplateRetrieveApiResponse,
        TemplateRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/api/templates/${queryArg.id}/` }),
        providesTags: ["templates"],
      }),
      templateUpdate: build.mutation<
        TemplateUpdateApiResponse,
        TemplateUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateTemplate,
        }),
        invalidatesTags: ["templates"],
      }),
      templateDelete: build.mutation<
        TemplateDeleteApiResponse,
        TemplateDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["templates"],
      }),
      templateExtractFields: build.mutation<
        TemplateExtractFieldsApiResponse,
        TemplateExtractFieldsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/extract-fields/`,
          method: "POST",
        }),
        invalidatesTags: ["templates"],
      }),
      templateFields: build.query<
        TemplateFieldsApiResponse,
        TemplateFieldsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/fields/`,
          params: {
            matter_id: queryArg.matterId,
            coverage_id: queryArg.coverageId,
          },
        }),
        providesTags: ["templates"],
      }),
      templateFieldDetail2: build.mutation<
        TemplateFieldDetail2ApiResponse,
        TemplateFieldDetail2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/fields/${queryArg.fieldId}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateTemplateField,
        }),
        invalidatesTags: ["templates"],
      }),
      templateFieldDetail: build.mutation<
        TemplateFieldDetailApiResponse,
        TemplateFieldDetailApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/fields/${queryArg.fieldId}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["templates"],
      }),
      templateImages: build.query<
        TemplateImagesApiResponse,
        TemplateImagesApiArg
      >({
        query: (queryArg) => ({ url: `/api/templates/${queryArg.id}/images/` }),
        providesTags: ["templates"],
      }),
      templateImageRemap: build.mutation<
        TemplateImageRemapApiResponse,
        TemplateImageRemapApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/images/${queryArg.imageId}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateTemplateImage,
        }),
        invalidatesTags: ["templates"],
      }),
      templateNewVersion: build.mutation<
        TemplateNewVersionApiResponse,
        TemplateNewVersionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/new-version/`,
          method: "POST",
        }),
        invalidatesTags: ["templates"],
      }),
      templateReanalyze: build.mutation<
        TemplateReanalyzeApiResponse,
        TemplateReanalyzeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/reanalyze/`,
          method: "POST",
        }),
        invalidatesTags: ["templates"],
      }),
      templateRender: build.mutation<
        TemplateRenderApiResponse,
        TemplateRenderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/render/`,
          method: "POST",
          body: queryArg.renderTemplateRequest,
        }),
        invalidatesTags: ["templates"],
      }),
      templateRenderToPdf: build.mutation<
        TemplateRenderToPdfApiResponse,
        TemplateRenderToPdfApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/render-to-pdf/`,
          method: "POST",
          body: queryArg.renderTemplateRequest,
        }),
        invalidatesTags: ["templates"],
      }),
      templateRestoreVersion: build.mutation<
        TemplateRestoreVersionApiResponse,
        TemplateRestoreVersionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/restore-version/`,
          method: "POST",
          params: {
            version: queryArg.version,
          },
        }),
        invalidatesTags: ["templates"],
      }),
      templateSetDefault: build.mutation<
        TemplateSetDefaultApiResponse,
        TemplateSetDefaultApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/set-default/`,
          method: "POST",
        }),
        invalidatesTags: ["templates"],
      }),
      templateSigningConfigCreate: build.mutation<
        TemplateSigningConfigCreateApiResponse,
        TemplateSigningConfigCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/signing-config/`,
          method: "POST",
          body: queryArg.createSigningConfig,
        }),
        invalidatesTags: ["templates"],
      }),
      templateSigningConfigUpdate: build.mutation<
        TemplateSigningConfigUpdateApiResponse,
        TemplateSigningConfigUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/signing-config/`,
          method: "PATCH",
          body: queryArg.patchedUpdateSigningConfig,
        }),
        invalidatesTags: ["templates"],
      }),
      templateSigningConfigDelete: build.mutation<
        TemplateSigningConfigDeleteApiResponse,
        TemplateSigningConfigDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/signing-config/`,
          method: "DELETE",
        }),
        invalidatesTags: ["templates"],
      }),
      templateUnsetDefault: build.mutation<
        TemplateUnsetDefaultApiResponse,
        TemplateUnsetDefaultApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/${queryArg.id}/unset-default/`,
          method: "POST",
        }),
        invalidatesTags: ["templates"],
      }),
      templateBulkArchive: build.mutation<
        TemplateBulkArchiveApiResponse,
        TemplateBulkArchiveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/bulk-archive/`,
          method: "POST",
          body: queryArg.bulkTemplateIdsRequest,
        }),
        invalidatesTags: ["templates"],
      }),
      templateContextFields: build.query<
        TemplateContextFieldsApiResponse,
        TemplateContextFieldsApiArg
      >({
        query: () => ({ url: `/api/templates/context-fields/` }),
        providesTags: ["templates"],
      }),
      templateNormalizePdf: build.mutation<
        TemplateNormalizePdfApiResponse,
        TemplateNormalizePdfApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/normalize-pdf/`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["templates"],
      }),
      templateResolve: build.query<
        TemplateResolveApiResponse,
        TemplateResolveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/resolve/`,
          params: {
            category: queryArg.category,
            firm_id: queryArg.firmId,
          },
        }),
        providesTags: ["templates"],
      }),
      templateVersionHistory: build.query<
        TemplateVersionHistoryApiResponse,
        TemplateVersionHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/templates/version-history/`,
          params: {
            version_group: queryArg.versionGroup,
          },
        }),
        providesTags: ["templates"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type TemplateListApiResponse =
  /** status 200  */ PaginatedReadTemplateSummaryList;
export type TemplateListApiArg = {
  /** Filter by template category. Supports multiple values via repeated params (e.g., ?category=RETAINER&category=OTHER) or comma-separated values (?category=RETAINER,OTHER). */
  category?:
    | "DROP_LETTER"
    | "FOIA_LETTER"
    | "HIPAA_AUTHORIZATION"
    | "HIPAA_AUTHORIZATION_RETAINER"
    | "HIPAA_COVERSHEET"
    | "JOINT_VENTURE_NOTICE"
    | "LIEN_NOTICE"
    | "LOR_FIRST_PARTY"
    | "LOR_GENERIC"
    | "LOR_HEALTH"
    | "LOR_THIRD_PARTY"
    | "OTHER"
    | "RETAINER"
    | "WELCOME_LETTER"
    | "CLIENT_COMMUNICATION"
    | "MEDICAL_RECORDS_REQUEST"
    | "AFFIDAVIT"
    | "LETTER_OF_PROTECTION"
    | "PRESERVATION_LETTER"
    | "PIP_DEMAND"
    | "FIRM_AUTHORIZATION";
  /** Filter by firm ID. Supports multiple values via repeated params (e.g., ?firm_id=<id1>&firm_id=<id2>) or comma-separated values. Use "__GLOBAL__" to include global templates. */
  firmId?: string;
  /** Filter by default status. */
  isDefault?: boolean;
  /** Number of results to return (default 100, max 500). */
  limit?: number;
  /** Starting position in the result set. */
  offset?: number;
  /** Sort by a field. Prefix with '-' for descending order (e.g., '-modified_at'). */
  ordering?:
    | "-category"
    | "-created_at"
    | "-firm"
    | "-format"
    | "-is_default"
    | "-modified_at"
    | "-name"
    | "-version"
    | "category"
    | "created_at"
    | "firm"
    | "format"
    | "is_default"
    | "modified_at"
    | "name"
    | "version";
  /** Filter by scope (GLOBAL or FIRM). */
  scope?: "FIRM" | "GLOBAL";
  /** Search by name, display name, description, or firm name (case-insensitive). Supports acronym-style firm searches (e.g., KRLG, K.R.L.G). */
  search?: string;
  /** Filter by status. */
  status?: "ACTIVE" | "ARCHIVED" | "SUPERSEDED";
  /** Filter by template format. Supports multiple values via repeated params (e.g., ?template_format=DOCX&template_format=PDF) or comma-separated values (?template_format=DOCX,PDF). */
  templateFormat?: "DOCX" | "EXTERNAL" | "HTML" | "PDF" | "SMS";
};
export type TemplateCreateApiResponse = /** status 201  */ ReadTemplate;
export type TemplateCreateApiArg = {
  createTemplate: CreateTemplate;
};
export type TemplateRetrieveApiResponse =
  /** status 200  */ ReadTemplateDetailRead;
export type TemplateRetrieveApiArg = {
  id: string;
};
export type TemplateUpdateApiResponse = /** status 200  */ ReadTemplate;
export type TemplateUpdateApiArg = {
  id: string;
  patchedUpdateTemplate: UpdateTemplate;
};
export type TemplateDeleteApiResponse = unknown;
export type TemplateDeleteApiArg = {
  id: string;
};
export type TemplateExtractFieldsApiResponse =
  /** status 200  */ FieldExtractionResponse;
export type TemplateExtractFieldsApiArg = {
  id: string;
};
export type TemplateFieldsApiResponse = /** status 200  */ ReadTemplateField;
export type TemplateFieldsApiArg = {
  id: string;
  /** Matter ID — when provided, fields are populated with context defaults. */
  matterId?: string;
  /** Coverage ID — used with matterId for insurance context fields. */
  coverageId?: string;
};
export type TemplateFieldDetail2ApiResponse =
  /** status 200  */ ReadTemplateField;
export type TemplateFieldDetail2ApiArg = {
  fieldId: string;
  id: string;
  patchedUpdateTemplateField: UpdateTemplateField;
};
export type TemplateFieldDetailApiResponse =
  /** status 200  */ ReadTemplateField;
export type TemplateFieldDetailApiArg = {
  fieldId: string;
  id: string;
};
export type TemplateImagesApiResponse = /** status 200  */ ReadTemplateImage;
export type TemplateImagesApiArg = {
  id: string;
};
export type TemplateImageRemapApiResponse =
  /** status 200  */ ReadTemplateImage;
export type TemplateImageRemapApiArg = {
  id: string;
  imageId: string;
  patchedUpdateTemplateImage: UpdateTemplateImage;
};
export type TemplateNewVersionApiResponse = /** status 201  */ ReadTemplate;
export type TemplateNewVersionApiArg = {
  id: string;
};
export type TemplateReanalyzeApiResponse =
  /** status 200  */ FieldExtractionResponse;
export type TemplateReanalyzeApiArg = {
  id: string;
};
export type TemplateRenderApiResponse = unknown;
export type TemplateRenderApiArg = {
  id: string;
  renderTemplateRequest: RenderTemplateRequest;
};
export type TemplateRenderToPdfApiResponse = unknown;
export type TemplateRenderToPdfApiArg = {
  id: string;
  renderTemplateRequest: RenderTemplateRequest;
};
export type TemplateRestoreVersionApiResponse = /** status 201  */ ReadTemplate;
export type TemplateRestoreVersionApiArg = {
  id: string;
  /** The version number to restore. */
  version: number;
};
export type TemplateSetDefaultApiResponse = /** status 200  */ ReadTemplate;
export type TemplateSetDefaultApiArg = {
  id: string;
};
export type TemplateSigningConfigCreateApiResponse =
  /** status 201  */ ReadSigningConfig;
export type TemplateSigningConfigCreateApiArg = {
  id: string;
  createSigningConfig: CreateSigningConfig;
};
export type TemplateSigningConfigUpdateApiResponse =
  /** status 200  */ ReadSigningConfig;
export type TemplateSigningConfigUpdateApiArg = {
  id: string;
  patchedUpdateSigningConfig: UpdateSigningConfig;
};
export type TemplateSigningConfigDeleteApiResponse = unknown;
export type TemplateSigningConfigDeleteApiArg = {
  id: string;
};
export type TemplateUnsetDefaultApiResponse = /** status 200  */ ReadTemplate;
export type TemplateUnsetDefaultApiArg = {
  id: string;
};
export type TemplateBulkArchiveApiResponse =
  /** status 200  */ BulkTemplateOperationResponse;
export type TemplateBulkArchiveApiArg = {
  bulkTemplateIdsRequest: BulkTemplateIdsRequest;
};
export type TemplateContextFieldsApiResponse = /** status 200  */ {
  [key: string]: any;
};
export type TemplateContextFieldsApiArg = void;
export type TemplateNormalizePdfApiResponse = unknown;
export type TemplateNormalizePdfApiArg = {
  body: {
    file: Blob;
  };
};
export type TemplateResolveApiResponse =
  /** status 200  */ ReadTemplateResolution;
export type TemplateResolveApiArg = {
  /** Template category to resolve. */
  category:
    | "DROP_LETTER"
    | "FOIA_LETTER"
    | "HIPAA_AUTHORIZATION"
    | "HIPAA_AUTHORIZATION_RETAINER"
    | "HIPAA_COVERSHEET"
    | "JOINT_VENTURE_NOTICE"
    | "LIEN_NOTICE"
    | "LOR_FIRST_PARTY"
    | "LOR_GENERIC"
    | "LOR_HEALTH"
    | "LOR_THIRD_PARTY"
    | "OTHER"
    | "RETAINER"
    | "WELCOME_LETTER"
    | "CLIENT_COMMUNICATION"
    | "MEDICAL_RECORDS_REQUEST"
    | "AFFIDAVIT"
    | "LETTER_OF_PROTECTION"
    | "PRESERVATION_LETTER"
    | "PIP_DEMAND"
    | "FIRM_AUTHORIZATION";
  /** Firm ID for firm-specific resolution. */
  firmId?: string;
};
export type TemplateVersionHistoryApiResponse =
  /** status 200  */ ReadTemplateVersion;
export type TemplateVersionHistoryApiArg = {
  /** Version group UUID. */
  versionGroup: string;
};
export type TemplateFormat = "PDF" | "DOCX" | "HTML" | "SMS" | "EXTERNAL";
export type TemplateCategory =
  | "HIPAA_COVERSHEET"
  | "HIPAA_AUTHORIZATION"
  | "HIPAA_AUTHORIZATION_RETAINER"
  | "FOIA_LETTER"
  | "LIEN_NOTICE"
  | "RETAINER"
  | "LOR_GENERIC"
  | "LOR_FIRST_PARTY"
  | "LOR_THIRD_PARTY"
  | "LOR_HEALTH"
  | "WELCOME_LETTER"
  | "DROP_LETTER"
  | "JOINT_VENTURE_NOTICE"
  | "CLIENT_COMMUNICATION"
  | "MEDICAL_RECORDS_REQUEST"
  | "AFFIDAVIT"
  | "LETTER_OF_PROTECTION"
  | "PRESERVATION_LETTER"
  | "PIP_DEMAND"
  | "FIRM_AUTHORIZATION"
  | "OTHER";
export type TemplateScope = "GLOBAL" | "FIRM";
export type TemplateStatus = "ACTIVE" | "SUPERSEDED" | "ARCHIVED";
export type ReadTemplateSummary = {
  id: string | string;
  name: string;
  display_name?: string | null;
  format: TemplateFormat;
  category: TemplateCategory;
  scope: TemplateScope;
  firm_id?: (string | string) | null;
  attorney_id?: (string | string) | null;
  attorney_name?: string | null;
  status: TemplateStatus;
  is_default: boolean;
  is_generic_template?: boolean;
  requires_signatures?: boolean;
  sample_render_status?: string | null;
  preview_render_url?: string | null;
  preview_image_url?: string | null;
  version: number;
  version_group: string;
  created_at: string;
  modified_at: string;
};
export type PaginatedReadTemplateSummaryList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ReadTemplateSummary[];
};
export type ExternalSystem = "ADOBE_SIGN";
export type ReadTemplate = {
  id: string | string;
  name: string;
  display_name?: string | null;
  description?: string | null;
  format: TemplateFormat;
  category: TemplateCategory;
  scope: TemplateScope;
  firm_id?: (string | string) | null;
  attorney_id?: (string | string) | null;
  attorney_name?: string | null;
  body?: string | null;
  file_url?: string | null;
  external_system?: ExternalSystem;
  external_id?: string | null;
  preview_render_url?: string | null;
  preview_image_url?: string | null;
  sample_render_status?: string | null;
  status: TemplateStatus;
  is_default: boolean;
  is_generic_template?: boolean;
  version: number;
  version_group: string;
  deleted_at?: string | null;
  created_at: string;
  modified_at: string;
};
export type SigningProvider = "ADOBE_SIGN";
export type CreateSigningConfig = {
  provider?: SigningProvider;
  client_signature_required?: boolean;
  attorney_signature_required?: boolean;
  default_attorney_id?: (string | string) | null;
};
export type MigratedFrom =
  | "DOCUMENT_TEMPLATE"
  | "DOCX_TEMPLATE"
  | "PDF_TEMPLATE";
export type CreateTemplate = {
  name?: string;
  display_name?: string | null;
  description?: string | null;
  body?: string | null;
  format?: TemplateFormat;
  category?: TemplateCategory;
  scope?: TemplateScope;
  firm_id?: (string | string) | null;
  attorney_id?: (string | string) | null;
  external_system?: ExternalSystem;
  external_id?: string | null;
  is_default?: boolean;
  signing_config?: CreateSigningConfig;
  migrated_from?: MigratedFrom;
  migrated_from_document_template_id?: (string | string) | null;
  migrated_from_docx_template_id?: (string | string) | null;
  migrated_from_pdf_template_id?: (string | string) | null;
};
export type FieldType =
  | "TEXT"
  | "DATE"
  | "CHECKBOX"
  | "IMAGE"
  | "ARRAY"
  | "SIGNATURE"
  | "INITIALS";
export type FieldSource = "MANUAL" | "CONTEXT" | "SIGNING";
export type MatterContextField =
  | "firmName"
  | "firmFullName"
  | "firmParalegalSig"
  | "firmManagingParalegalName"
  | "firmManagingParalegalEmail"
  | "firmManagingParalegalInitials"
  | "firmManagingParalegalPhone"
  | "firmEmail"
  | "firmPhone"
  | "firmAddress"
  | "firmAddress1"
  | "firmAddress2"
  | "firmState"
  | "firmPreFilingContingencyFee"
  | "firmPostFilingContingencyFee"
  | "firmLetterheadImageUrl"
  | "firmFooterImageUrl"
  | "firmLogoImageUrl"
  | "firmWatermarkImageUrl"
  | "matterName"
  | "matterStatus"
  | "matterMatterType"
  | "matterDateOfLoss"
  | "matterCity"
  | "matterState"
  | "matterStatuteOfLimitationsDate"
  | "attorneyName"
  | "attorneyFirstName"
  | "attorneyLastName"
  | "attorneyEmail"
  | "attorneyPhone"
  | "attorneyBarNumber"
  | "attorneyTitle"
  | "attorneyInitials"
  | "attorneySig"
  | "clientName"
  | "clientFirstName"
  | "clientLastName"
  | "clientEmail"
  | "clientDateOfBirth"
  | "clientAddress"
  | "clientAddress1"
  | "clientAddress2"
  | "clientAddress3"
  | "clientCity"
  | "clientState"
  | "clientZip"
  | "clientPhone"
  | "clientLastFourOfSsn"
  | "clientSsn"
  | "clientHipaaSignedDate"
  | "clientHipaaSigUrl"
  | "clientHipaaCleanedSigUrl"
  | "policeName"
  | "policeAddress"
  | "policePhone"
  | "policeEmail"
  | "policePoliceReportNumber"
  | "policeReportedIncidentDate"
  | "incidentIncidentType"
  | "policeDescription"
  | "policeReportedLocation"
  | "policeAttestationStatus"
  | "policeAddress1"
  | "policeAddress2"
  | "medicalName"
  | "medicalDatesOfService"
  | "medicalTreatment"
  | "medicalAddress"
  | "medicalAddress1"
  | "medicalAddress2"
  | "medicalPhone"
  | "medicalEmail"
  | "medicalStillTreating"
  | "medicalDateOfRecordsRequest"
  | "medicalServiceStartDate"
  | "medicalServiceEndDate"
  | "insuranceDateFiled"
  | "insurancePolicyType"
  | "insuranceHolder"
  | "insuranceCarrier"
  | "insurancePolicyNumber"
  | "insurancePolicyLimitations"
  | "insuranceVehicleDescription"
  | "insuranceClaimNumber"
  | "insuranceAdjusterName"
  | "insuranceAdjusterPhone"
  | "insuranceAdjusterEmail"
  | "insuranceMemberId"
  | "insuranceGroupId"
  | "insuranceAddress"
  | "insuranceAddress1"
  | "insuranceAddress2"
  | "insuranceCarrierFax"
  | "insuranceContactMethod"
  | "insuranceHealthCarrierProgramName"
  | "incidentDescription"
  | "incidentDateOfLoss"
  | "incidentTimeOfLoss"
  | "incidentLocation"
  | "incidentInjuriesDescribed"
  | "incidentHospital"
  | "incidentAmbulance"
  | "incidentAtFaultName"
  | "incidentAtFaultAddress1"
  | "incidentAtFaultAddress2"
  | "incidentPremisesName"
  | "incidentPremisesAddress1"
  | "incidentPremisesAddress2"
  | "incidentMinus2HoursLossTime"
  | "incidentPlus2HoursLossTime"
  | "treatmentRequestDate"
  | "treatmentChannelType"
  | "treatmentChannelAddress"
  | "treatmentChannelValue"
  | "treatmentChannelPortalRequestId"
  | "transmissionDate"
  | "transmissionMethod"
  | "transmissionOneWeekFromToday"
  | "recipientName"
  | "recipientAddress1"
  | "recipientAddress2"
  | "recipientCity"
  | "recipientState"
  | "recipientZip"
  | "recipientFullAddress"
  | "matterMedicalList"
  | "clientInjuries"
  | "insurance1pCarrier"
  | "insurance1pPolicyNumber"
  | "insurance1pClaimNumber"
  | "insurance1pAdjusterName"
  | "insurance1pAdjusterPhone"
  | "insurance1pAdjusterEmail"
  | "insurance1pPolicyLimitations"
  | "insurance3pCarrier"
  | "insurance3pPolicyNumber"
  | "insurance3pClaimNumber"
  | "insurance3pAdjusterName"
  | "insurance3pAdjusterPhone"
  | "insurance3pAdjusterEmail"
  | "insurance3pPolicyLimitations"
  | "insuranceHealthCarrier"
  | "insuranceHealthPolicyNumber"
  | "insuranceHealthMemberId"
  | "insuranceHealthGroupId"
  | "insuranceHealthAdjusterName"
  | "insuranceHealthAdjusterPhone"
  | "insuranceHealthAdjusterEmail"
  | "foia";
export type MatterContextCategory =
  | "firm"
  | "matter"
  | "attorney"
  | "client"
  | "police"
  | "medical"
  | "insurance"
  | "insurance1p"
  | "insurance3p"
  | "insuranceHealth"
  | "incident"
  | "treatmentRequest"
  | "treatmentChannel"
  | "transmission"
  | "recipient"
  | "foia";
export type ContextCategoryMeta = {
  label: string;
  binding_key?: string | null;
  entity_absent_hint?: string | null;
};
export type MatterContextFieldType =
  | "text"
  | "date"
  | "number"
  | "boolean"
  | "datetime"
  | "image"
  | "array"
  | "object";
export type ArrayItemProperty = {
  key: string;
  type: MatterContextFieldType;
  label: string;
  required?: boolean;
};
export type PdfPosition = {
  x: number;
  y: number;
  width: number;
  height: number;
};
export type ReadTemplateField = {
  id: string | string;
  template_id: string | string;
  reference: string;
  field_type: FieldType;
  source: FieldSource;
  context_key?: MatterContextField;
  context_category?: MatterContextCategory;
  context_category_meta?: ContextCategoryMeta;
  array_item_schema?: ArrayItemProperty[] | null;
  array_item_keys?: string[] | null;
  default_value?: string | null;
  required: boolean;
  display_name?: string | null;
  pdf_page_number?: number | null;
  pdf_position?: PdfPosition;
  created_at: string;
  modified_at: string;
};
export type ReadTemplateImage = {
  id: string | string;
  template_id: string | string;
  rel_path: string;
  content_hash: string;
  width: number;
  height: number;
  size_bytes: number;
  context_key?: string | null;
  file_url?: string | null;
  created_at: string;
  modified_at: string;
};
export type ReadSigningConfig = {
  id: string | string;
  template_id: string | string;
  provider: SigningProvider;
  client_signature_required: boolean;
  attorney_signature_required: boolean;
  default_attorney_id?: (string | string) | null;
  created_at: string;
  modified_at: string;
};
export type ReadTemplateDetail = {
  id: string | string;
  name: string;
  display_name?: string | null;
  description?: string | null;
  format: TemplateFormat;
  category: TemplateCategory;
  scope: TemplateScope;
  firm_id?: (string | string) | null;
  attorney_id?: (string | string) | null;
  attorney_name?: string | null;
  body?: string | null;
  file_url?: string | null;
  external_system?: ExternalSystem;
  external_id?: string | null;
  preview_render_url?: string | null;
  preview_image_url?: string | null;
  sample_render_status?: string | null;
  status: TemplateStatus;
  is_default: boolean;
  is_generic_template?: boolean;
  version: number;
  version_group: string;
  deleted_at?: string | null;
  created_at: string;
  modified_at: string;
  fields?: ReadTemplateField[];
  images?: ReadTemplateImage[];
  signing_config?: ReadSigningConfig;
};
export type ReadTemplateDetailRead = {
  id: string | string;
  name: string;
  display_name?: string | null;
  description?: string | null;
  format: TemplateFormat;
  category: TemplateCategory;
  scope: TemplateScope;
  firm_id?: (string | string) | null;
  attorney_id?: (string | string) | null;
  attorney_name?: string | null;
  body?: string | null;
  file_url?: string | null;
  external_system?: ExternalSystem;
  external_id?: string | null;
  preview_render_url?: string | null;
  preview_image_url?: string | null;
  sample_render_status?: string | null;
  status: TemplateStatus;
  is_default: boolean;
  is_generic_template?: boolean;
  version: number;
  version_group: string;
  deleted_at?: string | null;
  created_at: string;
  modified_at: string;
  fields?: ReadTemplateField[];
  images?: ReadTemplateImage[];
  signing_config?: ReadSigningConfig;
  /** Whether the template requires e-signatures (signing config exists). */
  requires_signatures: boolean;
};
export type UpdateTemplate = {
  name?: string | null;
  display_name?: string | null;
  description?: string | null;
  body?: string | null;
  category?: TemplateCategory;
  status?: TemplateStatus;
  is_default?: boolean | null;
  is_generic_template?: boolean | null;
  attorney_id?: (string | string) | null;
};
export type ReadAnalysisError = {
  phase: string;
  message: string;
  detail?: string | null;
};
export type FieldExtractionResponse = {
  fields: ReadTemplateField[];
  analysis_errors?: ReadAnalysisError[];
};
export type UpdateTemplateField = {
  reference?: string | null;
  field_type?: FieldType;
  source?: FieldSource;
  context_key?: MatterContextField;
  default_value?: string | null;
  required?: boolean | null;
  display_name?: string | null;
  pdf_page_number?: number | null;
  pdf_position?: PdfPosition;
};
export type UpdateTemplateImage = {
  context_key?: string | null;
};
export type RenderTemplateRequest = {
  fields?: {
    [key: string]:
      | (
          | string
          | any[]
          | {
              [key: string]: any;
            }
        )
      | null;
  };
  matter_id?: (string | string) | null;
};
export type UpdateSigningConfig = {
  provider?: SigningProvider;
  client_signature_required?: boolean | null;
  attorney_signature_required?: boolean | null;
  default_attorney_id?: (string | string) | null;
};
export type BulkTemplateSkipped = {
  template_id: string | string;
  reason: string;
};
export type BulkTemplateOperationResponse = {
  processed_count: number;
  skipped?: BulkTemplateSkipped[];
};
export type BulkTemplateIdsRequest = {
  ids: (string | string)[];
};
export type ReadTemplateResolution = {
  template?: ReadTemplate;
  source_tier: string;
};
export type ReadTemplateVersion = {
  id: string | string;
  version: number;
  status: TemplateStatus;
  created_at: string;
};
export const {
  useTemplateListQuery,
  useTemplateCreateMutation,
  useTemplateRetrieveQuery,
  useTemplateUpdateMutation,
  useTemplateDeleteMutation,
  useTemplateExtractFieldsMutation,
  useTemplateFieldsQuery,
  useTemplateFieldDetail2Mutation,
  useTemplateFieldDetailMutation,
  useTemplateImagesQuery,
  useTemplateImageRemapMutation,
  useTemplateNewVersionMutation,
  useTemplateReanalyzeMutation,
  useTemplateRenderMutation,
  useTemplateRenderToPdfMutation,
  useTemplateRestoreVersionMutation,
  useTemplateSetDefaultMutation,
  useTemplateSigningConfigCreateMutation,
  useTemplateSigningConfigUpdateMutation,
  useTemplateSigningConfigDeleteMutation,
  useTemplateUnsetDefaultMutation,
  useTemplateBulkArchiveMutation,
  useTemplateContextFieldsQuery,
  useTemplateNormalizePdfMutation,
  useTemplateResolveQuery,
  useTemplateVersionHistoryQuery,
} = injectedRtkApi;
